
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../../controlador';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Cargando: boolean = false;
        public get Ok(): boolean
        {
            return !!this.Pedido;
        }

        public async Ejecutar()
        {

            this.Cargando = true;
            let pdf = await Pedido.URLNotaMercadoPago( [this.Pedido] );
            if ( pdf )
            {
                //p.Estado = Pedidos.Estados.Preparando;
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar el formulario` );

            }
            this.Cargando = false;
        }

    }
